import { Auth } from "@aws-amplify/auth";
import cn from "classnames";

import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import ContactMailIcon from "@mui/icons-material/ContactMail";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import FavoriteIcon from "@mui/icons-material/Favorite";
import HandshakeIcon from "@mui/icons-material/Handshake";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import LogoutIcon from "@mui/icons-material/Logout";
import NotificationsIcon from "@mui/icons-material/Notifications";
import SettingsIcon from "@mui/icons-material/Settings";
import {
  Avatar,
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Link from "@mui/material/Link";

import { siteName } from "@/constants/config";
import useNavigateLogin from "@/hooks/useNavigateLogin";
import usePlatform from "@/hooks/usePlatform";
import useUserInfo from "@/hooks/useUserInfo";

const UserInfoMenu = () => {
  const { userInfoContext } = useUserInfo();

  const { navigateLogin, saveCurrentUrl } = useNavigateLogin();

  const navigator = useNavigate();
  const showSignUp = useMediaQuery("(min-width:500px)");

  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const { isPc } = usePlatform();

  const handleOpenUserMenu = useCallback((event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  }, []);

  const handleLoginOut = useCallback(async () => {
    try {
      localStorage.removeItem("jwtToken");
      userInfoContext.setUserInfo(undefined);
      localStorage.clear();
      await Auth.signOut();
      saveCurrentUrl();
    } catch (error) {
      //
    }

    setAnchorElUser(null);
  }, [userInfoContext, saveCurrentUrl]);

  const profile_img = userInfoContext.userInfo?.profile_img;

  return (
    <Box className="flex items-center">
      {userInfoContext.userInfo ? (
        <>
          <IconButton onClick={() => navigator("/setting/preferred-programs")}>
            <FavoriteIcon className="text-[#fff]" fontSize="small" />
          </IconButton>
          <IconButton onClick={() => navigator("/alert")}>
            <NotificationsIcon className="text-[#fff]" fontSize="small" />
          </IconButton>
          <Tooltip title={userInfoContext.userInfo.email} enterDelay={500}>
            <IconButton
              onClick={handleOpenUserMenu}
              sx={{ p: 0 }}
              className={isPc ? "!ml-[12px]" : "!ml-[4px]"}
            >
              <Avatar src={profile_img}>{userInfoContext.userInfo.email[0].toUpperCase()}</Avatar>
            </IconButton>
          </Tooltip>
          <Menu
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(anchorElUser)}
            onClose={() => setAnchorElUser(null)}
          >
            {/* <MenuItem
              onClick={() => {
                navigator("/setting/plan");
              }}
            >
              <EmojiPeopleIcon color="primary" className="inline-block mr-[8px] !text-[18px]" />
              <Typography textAlign="center">Referral</Typography>
            </MenuItem> */}
            <MenuItem
              onClick={() => {
                navigator("/setting/plan");
              }}
            >
              <SettingsIcon color="primary" className="inline-block mr-[8px] !text-[18px]" />
              <Typography textAlign="center">Setting</Typography>
            </MenuItem>
            <MenuItem
              onClick={() => {
                navigator("/setting/referral");
              }}
            >
              <Diversity3Icon color="primary" className="inline-block mr-[8px] !text-[18px]" />
              <Typography textAlign="center">referral</Typography>
            </MenuItem>
            <MenuItem
              component={Link}
              href={
                "mailto:partnership@" +
                siteName +
                ".com?subject=" +
                siteName +
                " Feedback&body=Welcome! You're welcomed to join our affiliate family and turn your passion into profits with our generous terms. Let's grow together! 🚀💰 Tell us more about yourself."
              }
              sx={{
                padding: 16,
                paddingY: 6,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <CurrencyExchangeIcon
                color="primary"
                className="inline-block mr-[8px] !text-[18px]"
              />
              <Typography textAlign="center">Affiliate</Typography>
            </MenuItem>
            <MenuItem
              onClick={() => {
                navigator("/contact");
              }}
            >
              <ContactMailIcon color="primary" className="inline-block mr-[8px] !text-[14px]" />
              <Typography textAlign="center">Contact</Typography>
            </MenuItem>
            <MenuItem
              onClick={() => {
                navigator("/guides");
              }}
            >
              <LocalOfferIcon color="primary" className="inline-block mr-[8px] !text-[18px]" />
              <Typography textAlign="center">Guides</Typography>
            </MenuItem>
            <MenuItem onClick={handleLoginOut}>
              <LogoutIcon color="primary" className="inline-block mr-[8px] !text-[18px]" />
              <Typography textAlign="center">Log out</Typography>
            </MenuItem>
          </Menu>
        </>
      ) : (
        <>
          <Button
            className={cn("!ml-[8px] !font-bold !text-[#fff]", showSignUp ? "!block" : "!hidden")}
            onClick={() => navigateLogin("/signup")}
          >
            Sign up
          </Button>
          <Button className="!font-bold !text-[#fff]" onClick={() => navigateLogin()}>
            Login
          </Button>
        </>
      )}
    </Box>
  );
};

export default React.memo(UserInfoMenu);
